import { render, staticRenderFns } from "./DoNotUseTempEmail.vue?vue&type=template&id=10eb0e4d"
import script from "./DoNotUseTempEmail.vue?vue&type=script&lang=js"
export * from "./DoNotUseTempEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports